import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {NzModalService} from 'ng-zorro-antd/modal';
import {ModalOptions} from 'ng-zorro-antd/modal/modal-types';

@Injectable()
export class ModalService {

    constructor(
        private modal: NzModalService,
        private translateService: TranslateService,
    ) {
    }

    confirm(options?: ModalOptions) {
        const modalOptions = {
            nzTitle: this.translateService.instant('LABELS.CONFIRMATION'),
            nzOkText: this.translateService.instant('LABELS.CONFIRM'),
            nzCancelText: this.translateService.instant('LABELS.CANCEL'),
            ...options
        };
        return this.modal.confirm(modalOptions);
    }

    generic(options?: ModalOptions) {
        return this.modal.create(options);
    }

    error(options?: ModalOptions) {
        const modalOptions = {
            nzTitle: this.translateService.instant('ERRORS.ERROR'),
            ...options
        };
        return this.modal.error(modalOptions);
    }
}
